import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostTourStatusCommandServiceModule } from '..';
import { PostTourStatusCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    PostTourStatusCommandServiceModule
  ],
  declarations: [PostTourStatusCommandComponent],
  exports: [PostTourStatusCommandComponent],

})
export class PostTourStatusCommandComponentModule { }
